// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.vendorsandpartners.insurancecompanies.RefundInsuranceResponse */
/* istanbul ignore next */
@GandalfModel
export class RefundInsuranceResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	amount!: number | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	invoiceId!: number | null;

	@GandalfProperty({ designType: String })
	referenceNumber!: string | null;

	@GandalfProperty({ designType: Date })
	refundDate!: Date | null;

	@GandalfConstantDecorator(constants.RefundFrom)
	@GandalfProperty({ designType: constants.RefundFrom })
	refundFrom!: constants.RefundFrom | null;

	@GandalfConstantDecorator(constants.RefundStatus)
	@GandalfProperty({ designType: constants.RefundStatus })
	status!: constants.RefundStatus | null;

}
